import React, { useState, useEffect } from "react";
import {
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  FormLabel,
  Button,
  Box,
  Alert,
  CircularProgress,
  IconButton,
  Typography,
  Divider,
  InputLabel,
  Checkbox,
  OutlinedInput,
  ListItemText,
  Avatar,
   Grid,
} from "@mui/material";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import { useAlert } from "../alerts/AlertContext";
import AxiosInstance from "../../services/AxiosInstance";
import { BRAND_URL } from "../../Constants/Constants";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { ThemeProvider } from "../v2/home/theme/ThemeProvider";
import { LocalizationProvider, DatePicker, TimePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import moment from "moment";
import {UploadFile, Delete} from '@mui/icons-material';

function BrandForm({ open, onClose, editData = null, onSuccess, isEditMode = false }) {
  
  const [loading, setLoading] = useState(false);
  
  const [productTitle, setProductTitle] = useState("");  
  const [companyName, setCompanyName] = useState("");  
  const [contactEmail, setContactEmail] = useState("");
  const [supportEmail, setSupportEmail] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  
  const [files, setFile] = useState();
  const showAlert = useAlert();
  const [brand, setBrand] = useState(null);
  // Initialize form data when dialog opens or editData changes
  useEffect(() => {
    if (open) {
      
      if (editData) {
       
        setProductTitle(editData.productTitle);  
        setCompanyName(editData.companyName);  
        setContactEmail(editData.contactEmail);
        setSupportEmail(editData.supportEmail);
        setContactPhone(editData.contactPhone);

         //const globalFile = convertBackendImage(editData.globalLogo, editData.globalLogoName, editData.globalLogoExtension);
         //const footerFile = convertBackendImage(editData.footerLogo, editData.footerLogoName, editData.footerLogoExtension);
         //const faviconFile = convertBackendImage(editData.faviconLogo, editData.faviconLogoName, editData.faviconLogoExtension);

         const globalFile = convertBackendImageToFile({bytes: editData.globalLogo, fileName: editData.globalLogoName, fileType: editData.globalLogoExtension});
         const footerFile = convertBackendImageToFile({bytes:editData.footerLogo, fileName:editData.footerLogoName, fileType: editData.footerLogoExtension});
         const faviconFile = convertBackendImageToFile({bytes:editData.faviconLogo, fileName:editData.faviconLogoName, fileType: editData.faviconLogoExtension});

        setLogos({
            global: globalFile,            
            footer: footerFile,
            favicon: faviconFile
        });
        
      } else {
        // setFormData({
        //   name: "",
        //   seq: "",
        //   active: true,
        // });
      }
      //setErrors({});
    }
  }, [open, editData]);
  
    
    function convertBackendImageToFile(data) {
        if (!data || !data.bytes) return null;

        // Handle byte[] of base64 OR base64 string
        const base64 = Array.isArray(data.bytes)
            ? new TextDecoder().decode(new Uint8Array(data.bytes))
            : data.bytes;

        const mime = data.fileType || "image/png";
        const fileName = data.fileName || `image.${mime.split("/")[1]}`;

        // Convert base64 → Blob
        const byteChars = atob(base64);
        const byteNums = new Uint8Array(byteChars.length);

        for (let i = 0; i < byteChars.length; i++) {
            byteNums[i] = byteChars.charCodeAt(i);
        }

        const blob = new Blob([byteNums], { type: mime });

        // Blob → File
        return new File([blob], fileName, { type: mime });
    }


    
  const handleProductTitleChange = (event) => {
    setProductTitle(event.target.value);
  };

  const handleCompanyNameChange = (event) => {
    setCompanyName(event.target.value);
  };

  const handleContactEmailChange = (event) => {
    setContactEmail(event.target.value);
  };

  const handleSupportEmailChange = (event) => {
    setSupportEmail(event.target.value);
  };

  const handleContactPhoneChange = (event) => {
    setContactPhone(event.target.value);
  };

    
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);

    try {

        const formData = new FormData();

        formData.append("productTitle", productTitle);
        formData.append("companyName", companyName);
        formData.append("contactEmail", contactEmail);
        formData.append("supportEmail", supportEmail);
        formData.append("contactPhone", contactPhone);
        if(isEditMode) 
            formData.append("brandId",  editData.id);

        /*Object.entries(logos).forEach(([key, value]) => {
            if (value) {
            const blob = dataURLtoBlob(value);
            formData.append(key, value);
            }
        });  */     
    
         Object.entries(logos).forEach(([key, file]) => {
            if (file) {
            formData.append(key, file); // ✅ direct file upload
            }
        });

      await AxiosInstance.post(BRAND_URL, formData);

      showAlert(
        `Brand ${isEditMode ? "updated" : "created"} successfully!`,
        "success"
      );

      onSuccess?.();
      onClose();
    } catch (error) {
      showAlert("Error saving Brand:", "error");
      showAlert(
        `Brand ${isEditMode ? "update" : "creation"} failed!`,
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      onClose();
    }
  };

   const [logos, setLogos] = useState({
    global: null,
    footer: null,
    favicon: null
  });

  const handleUpload = (type, event) => {
    const file = event.target.files[0];
    if (!file || !file.type.startsWith("image/")) {
      alert("Only image files allowed!");
      return;
    }

    setLogos(prev => ({
    ...prev,
    [type]: file    // ✅ store FILE object
    }));

  };

  const handleDelete = (type) => {
    setLogos(prev => ({ ...prev, [type]: null }));
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          minHeight: 450,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 1,
        }}
      >      
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {isEditMode ? (
            <EditIcon color="primary" />
          ) : (
            <AddIcon color="primary" />
          )}
          <Typography variant="h6" component="span">
            {isEditMode ? "Edit Brand" : "Add New Brand"}
          </Typography>
        </Box>
        <IconButton
          onClick={handleClose}
          disabled={loading}
          size="small"
          sx={{ color: "grey.500" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <Divider />

      <DialogContent sx={{ pt: 3 }}>
        <ThemeProvider>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
            <Box
              sx={{
                display: "flex",
                gap: 2,          // space between dropdowns
                width: "100%",   // full parent width
              }}
            >
               <Grid container spacing={3} justifyContent="center">

                    <Grid item>
                    <LogoUpload
                        title="Global Logo"
                        image={logos.global}
                        small
                        onUpload={(e) => handleUpload("global", e)}
                        onDelete={() => handleDelete("global")}
                    />
                    </Grid>

                    <Grid item>
                    <LogoUpload
                        title="Footer Logo"
                        image={logos.footer}
                        small
                        onUpload={(e) => handleUpload("footer", e)}
                        onDelete={() => handleDelete("footer")}
                    />
                    </Grid>

                    <Grid item>
                    <LogoUpload
                        title="Favicon"
                        image={logos.favicon}
                        small
                        onUpload={(e) => handleUpload("favicon", e)}
                        onDelete={() => handleDelete("favicon")}
                    />
                    </Grid>
                </Grid>
              
            </Box>   
            <Box
              sx={{
                display: "flex",
                gap: 2,          // space between dropdowns
                width: "100%",   // full parent width
              }}
            >
             <TextField
                autoFocus
                required
                margin="dense"
                id="outlined-multiline-static"
                name="productTitle"
                label="Product Title"
                type="text"
                variant="outlined"
                fullWidth
                value={productTitle}
                onChange={handleProductTitleChange}                
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="outlined-multiline-static"
                name="companyName"
                label="Company Name"
                type="text"
                variant="outlined"
                fullWidth
                value={companyName}
                onChange={handleCompanyNameChange}                
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,          // space between dropdowns
                width: "100%",   // full parent width
              }}
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="outlined-multiline-static"
                name="contactEmail"
                label="Contact Email"
                type="text"
                variant="outlined"
                fullWidth
                value={contactEmail}
                onChange={handleContactEmailChange}                
              />
              <TextField
                autoFocus
                required
                margin="dense"
                id="outlined-multiline-static"
                name="supportEmail"
                label="Support Email"
                type="text"
                variant="outlined"
                fullWidth
                value={supportEmail}
                onChange={handleSupportEmailChange}                
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                gap: 2,          // space between dropdowns
                width: "100%",   // full parent width
              }}
            >
              <TextField
                autoFocus
                required
                margin="dense"
                id="outlined-multiline-static"
                name="contactPhone"
                label="Contact Phone"
                type="text"
                variant="outlined"
                fullWidth
                value={contactPhone}
                onChange={handleContactPhoneChange}                
              />
            </Box>           
          <Alert severity="info" sx={{ mt: 2, borderRadius: 2 }}>
            {isEditMode
              ? "You are editing an existing notification."
              : "You are adding a new notification."}
          </Alert>          
        </Box>
        </LocalizationProvider>
        </ThemeProvider>
      </DialogContent>

      <Divider />

     <DialogActions sx={{ p: 3, gap: 1 }}>
        <Button
          onClick={handleClose}
          disabled={loading}
          variant="outlined"
          sx={{ borderRadius: 2 }}
        >
          Cancel
        </Button>
        <Button
          onClick={handleSubmit}
          disabled={loading}
          variant="contained"
          startIcon={loading ? <CircularProgress size={16} /> : <SaveIcon />}
          sx={{
            borderRadius: 2,
            minWidth: 120,
          }}
        >
          {loading ? "Saving..." : isEditMode ? "Update" : "Create"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

function LogoUpload({ title, image, onUpload, onDelete, small }) {
  return (
    <Box textAlign="center">
      <Typography>{title}</Typography>

      <Box position="relative" display="inline-block">
        <Avatar
          variant="rounded"
          //src={image}
          src={image ? URL.createObjectURL(image) : ""}
          sx={{
            width: small ? 70 : 150,
            height: small ? 70 : 80,
            bgcolor: "#f0f0f0"
          }}
        />

        {image && (
          <IconButton
            size="small"
            color="error"
            onClick={onDelete}
            sx={{
              position: "absolute",
              top: -8,
              right: -8,
              bgcolor: "#fff"
            }}
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>

      <br />

      <Button
        variant="outlined"
        component="label"
        size="small"
        sx={{ mt: 1 }}
        startIcon={<UploadFile />}
      >
        Upload
        <input hidden type="file" accept="image/*" onChange={onUpload} />        

      </Button>

    </Box>
  );
}

export default BrandForm;
